import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/miracle2006.css';
import Bg from '../images/Event/miracle2006/bg.png';
import Sticky from 'react-sticky-el';

var _timer = null;

class Miracle2006 extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    window.pageVisit("miracle", "2006");
  }

  render() {
    return (
      <div style={{backgroundColor: '#f9a835'}}>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont miracle" style={{background: '#f9a835'}}>
              <div id="contents" style={{background: '#f9a835'}}>
                <div><img src={Bg} style={{width: '100%'}} /></div>
              </div>
            </div>
          </div>
          <Sticky mode="bottom" bottomOffset={1000} stickyStyle={{ zIndex: 3 }}>
            <Link to="/event/branch/86" onClick={() => window.pageComplete("miracle", "2006")}><div className="miracle event-branch"></div></Link>
          </Sticky>  
        </div>
      </div>

    )
  }
}

export default Miracle2006;